export abstract class PageNavigator {
  public abstract setPageId(pageId: string): void;
  public abstract getPageId(): string;
  public abstract changePage(newCurrentPageId: string): boolean;
}
